import React, {useContext, useState, Fragment, useEffect} from "react";
import { AppContext } from "../../components/AppProvider";
import { GraphComponent } from "../common/Graph/Graph";
import { ScrollToTop } from "../common/ScrollToTop/ScrollToTop";
import { SubMenu, TYPES_EXERCISE } from "../Eocs/Menu";
import { Container, DateLayer } from "../Layout";
import { DateSetting } from "./DateSetting";
import { DoctorMsgBox } from "./DoctorMsgBox";
import { userHabit } from "../../modules/utils/UserHabit";
import { NativeAction } from "../../modules/utils/HandleWs";

export default (props) => {
    const {phonecfg} = useContext(AppContext);
    useEffect(()=>{
        userHabit(phonecfg, "EX120");
        NativeAction(phonecfg, "statusColor", "#7FD2C2");
    }, [phonecfg.version])
    return(
        <Fragment>
            <ScrollToTop />
            <Container Title={ TYPES_EXERCISE[1].label } /*bottom={list.length === 0 ? <Bottom /> : null}*/ goToUrl={'/'} >
                <div className="contents sub">
                    <SubMenu SUBS={TYPES_EXERCISE} code={TYPES_EXERCISE[1].code} />
                    <div className="sub-contents">
                        {/* 기간설정 */}
                        <DateSetting />
                        {/* 의사 메세지 박스 */}
                        <DoctorMsgBox />

                        {/* 걸음수 그래프 */}
                        <GraphComponent title="걸음수 그래프" />
                        <GraphComponent title="칼로리 그래프" zoomData={zoomData} />
                    </div>
                </div>
            </Container>
            <DateLayer color="green" />
        </Fragment>
    );
}

const zoomData = [
    {
        "barClass":"bargreen",
        "barLabel":"섭취칼로리"
    },
    {
        "barClass":"barblue",
        "barLabel":"운동/걷기 소모칼로리"
    },
    {
        "barClass":"barpink",
        "barLabel":"걷기 소모칼로리"
    }
];